/**
 * Gestion du panier en localStorage pour les visiteurs non connectés
 */

const CART_KEY = 'guest_cart';

export const cartStorage = {
  // Récupérer tous les articles du panier
  getItems() {
    try {
      const cart = localStorage.getItem(CART_KEY);
      return cart ? JSON.parse(cart) : [];
    } catch (err) {
      console.error('Error reading cart from localStorage:', err);
      return [];
    }
  },

  // Ajouter ou mettre à jour un article
  addItem(item) {
    try {
      const cart = this.getItems();
      
      // Vérifier si l'article existe déjà (même produit, couleur, option)
      const existingIndex = cart.findIndex(
        i => i.product_id === item.product_id && 
             i.color === item.color && 
             i.lens_option === item.lens_option
      );

      if (existingIndex >= 0) {
        // Mettre à jour la quantité
        cart[existingIndex].quantity += item.quantity;
      } else {
        // Ajouter un nouvel article avec un ID temporaire
        cart.push({
          ...item,
          id: `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
          created_at: new Date().toISOString()
        });
      }

      localStorage.setItem(CART_KEY, JSON.stringify(cart));
      return cart;
    } catch (err) {
      console.error('Error adding item to cart:', err);
      throw err;
    }
  },

  // Mettre à jour la quantité d'un article
  updateQuantity(itemId, quantity) {
    try {
      const cart = this.getItems();
      const index = cart.findIndex(i => i.id === itemId);
      
      if (index >= 0) {
        if (quantity <= 0) {
          cart.splice(index, 1);
        } else {
          cart[index].quantity = quantity;
        }
        localStorage.setItem(CART_KEY, JSON.stringify(cart));
      }
      
      return cart;
    } catch (err) {
      console.error('Error updating cart quantity:', err);
      throw err;
    }
  },

  // Supprimer un article
  removeItem(itemId) {
    try {
      const cart = this.getItems().filter(i => i.id !== itemId);
      localStorage.setItem(CART_KEY, JSON.stringify(cart));
      return cart;
    } catch (err) {
      console.error('Error removing item from cart:', err);
      throw err;
    }
  },

  // Vider le panier
  clear() {
    try {
      localStorage.removeItem(CART_KEY);
    } catch (err) {
      console.error('Error clearing cart:', err);
    }
  },

  // Obtenir le nombre total d'articles
  getCount() {
    const cart = this.getItems();
    return cart.reduce((sum, item) => sum + (item.quantity || 1), 0);
  }
};
